import ResultCard from '@component/ResultCard'
import { useTranslation } from 'react-i18next'
import { useBeam } from './context'

function BeamResult () {
  const { t } = useTranslation()
  const { form, result } = useBeam()

  const hidden = !form.formState.isSubmitSuccessful

  return (
    <ResultCard
      title={t('COMPOUND.RESULT', { label: 'GLOSSARY.BEAM' })}
      unit="mm"
      label={t('GLOSSARY.MIN_REQUIRED_DEPTH')}
      result={Number(result?.toFixed(0))}
      hidden={hidden}
    />
  )
}

export default BeamResult
